import { takeLatest, takeEvery, put, call } from "redux-saga/effects";
import { delay } from "redux-saga";
import get from "lodash.get";
import { pre1981options } from 'utils/pre1981vins.js'

import actions from "actions/actionTypes";
import {
  displayMessageAction,
  resetMessageAction
} from "actions/messageActions";


function* checkResponseMessagesSaga({ payload: response }) {
  try {
    const json = response.json
      ? yield call(response.json.bind(response))
      : response;
    let messages = json.messages || get(json, "details.messages", []);
    messages = messages.filter(message => message.type.toLowerCase() !== "info" && message.type.toLowerCase() !== "success");

    if (messages.length === 0) return;

    const messageObj = messages.reduce(
      (obj, msg) => {
        const curMsgType = get(msg, "type", "").toLowerCase();
        obj.type = get(obj, "type", curMsgType);

        if (obj.type !== curMsgType) {
          obj.type = "warning";
        }

        if (messages.length === 1) {
            if (msg.messageText === "Something went wrong: Unable to decode VIN.") {
                obj.text = msg.messageText + " Try adding the Make and the Year";
                pre1981options();
             }
            else {
                obj.text = msg.messageText;
            }
        } else {
          obj.text += `• ${msg.messageText}\n`;
        }
        return obj;
      },
      { text: "" }
    );

    yield put(displayMessageAction(messageObj));
    yield call(delay, 10000);
    yield put(resetMessageAction());
  } catch (error) {}
}

function* requestDisplayMessageSaga({ payload, delay: delayMs }) {
  yield put(displayMessageAction(payload));
  if (delayMs) {
    yield call(delay, delayMs);
    yield put(resetMessageAction());
  }
}
 

export const messageSagas = [
  takeEvery(
    [actions.API_REQUEST_SUCCESS, actions.API_REQUEST_FAILURE],
    checkResponseMessagesSaga
  ),
  takeLatest(actions.REQUEST_DISPLAY_MESSAGE, requestDisplayMessageSaga)
];
